import { createQueryFactory } from "#resources/hooks/integrations/query-factory";

function usePlaceData() {
	const { useApiHook: useCheckPlaceConfigQuery } = createQueryFactory("checkPlaceConfig");

	const { useApiHook: useGetPlaceContractDetailsQuery } = createQueryFactory(
		"getPlaceContractDetails",
	);
	return {
		useCheckPlaceConfigQuery,
		useGetPlaceContractDetailsQuery,
	};
}

export default usePlaceData;
